// This preview query is the same as a regular live GraphQL topic article query,
// but returns articles entries that are enabled or disabled.
// Note the schema token must allow querying disabled entries.
// Use the canonicalId for querying drafts with the live preview token
// passed in from the Craft preview page URL params as header x-craft-token
// to grab active drafts.

import { gql } from "@apollo/client";
import { entryFragments } from "./entryFragments";

// IMPORTANT: do not prettify this file.
// Some editors remove commas or directives in template strings when "prettifying".
// prettier-ignore
const LIVE_TOPIC_PREVIEW_QUERY = gql`
  query($id: [QueryArgument], $siteId: [QueryArgument]) {
    globalSets(siteId: $siteId) {
      handle
      ... on customerSupport_GlobalSet {
        localeSupportInfo {
          ... on supportblock_Entry {
            id
            localeTitle
            locality
            phone
            internationalPhone
            email
            addressLine1
            addressLine2
          }
        }
      }
      ... on translations_GlobalSet {
        translationKeyValuePairs {
          labelKey
          labelValue
        }
      }
    }

    globalVariables: entries(section:"variables", siteId:$siteId, type: ["variable"]) {
      id  # need id only for global variables as they may be overridden by product scoped variables, nested variables are not implemented yet
      ...VariableEntryFields
    }

    glossary: entries(section: "glossary", siteId: $siteId) {
      ... on glossaryTerm_Entry {
        id
        title
        definition { rawHtml }
      }
    }

    entry(id: $id, siteId: $siteId) {
      id
      siteId
      typeHandle

      # Handle our article entry types:
      ...ArticleWithStepsFields
      ...ArticleLongformFields
      ...ArticleLongformComposableEntriesFields
      ...ArticleStepByStepComposableEntriesFields
      # Handle individual block entry types:
      ...TextBlockFields
      ...TextPlusImageBlockFields
      ...RichTextInlineImagesBlockFields
      ...LargeImageBlockFields
      ...CalloutBlockFields
      ...VideoBlockFields
      ...FullWidthImageBlockFields
      ...ColumnComposableBlockFields
    }
  }

  # Inject the fragments from entryFragments.js:
  ${entryFragments}
`;

export default LIVE_TOPIC_PREVIEW_QUERY;